import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "queues";
const queues = createEndpointBase(base);

export const queuesEndpoints = {
  queueJobsJobInfo: queues({
    method: "GET",
    path: ":queueName/jobs/:jobId",
    request: z.any(),
    response: z.any(),
  }),
  queueJobsDownload: queues({
    method: "GET",
    path: ":queueName/jobs/:jobId/download",
    request: z.any(),
    response: z.any(),
  }),
} as const;
